<template>
    <multi-select-input
        :items="orderedPipelines"
        v-bind="$attrs"
        value-key-name="id"
        label-key-name="name"
    >
        <template #active-label="{ bindings }">
            <span v-if="bindings.value">
                <template v-if="props.variant === 'pipeline-with-company'">
                    {{ bindings.value.name }}
                    <text-decorator :size="FontSize.xs" :color="Color.gray400">
                        ({{ bindings.value.company.name }})
                    </text-decorator>
                </template>
                <template v-if="props.variant === 'pipeline'">
                    <chip-informative>
                        {{ bindings.value.name }}
                    </chip-informative>
                </template>
            </span>
            <span v-else>
                Kies een pijplijn
            </span>
        </template>
        <template #item="{ bindings }">
            <template v-if="props.variant === 'pipeline-with-company'">
                <pipeline-company-block :pipeline="bindings.item" />
            </template>
            <template v-if="props.variant === 'pipeline'">
                <span>
                    {{ bindings.item.name }}
                </span>
            </template>
        </template>
    </multi-select-input>
</template>

<script lang="ts" setup>
    import { MultiSelectInput, TextDecorator, FontSize, Color, ChipInformative } from '@keyvue/one-ui';
    import type { Pipeline } from '@keyvue/one-api-client';
    import PipelineCompanyBlock from '@components/Blocks/PipelineCompanyBlock.vue';
    import { computed } from 'vue';

    export interface Props {
        pipelines: Pipeline[]
        variant?: 'pipeline-with-company' | 'pipeline',
    }

    const props = withDefaults(defineProps<Props>(), {
        variant: 'pipeline-with-company',
    });

    const orderedPipelines = computed(() => (
        [...props.pipelines].sort((a, b) => a.name.localeCompare(b.name))
    ));
</script>
